<template>
  <div class="modal-overlay">
    <div class="modal">
      <h3>{{ session ? 'Edit Session' : 'Create New Session' }}</h3>
      
      <div class="form-group">
        <label>Date:</label>
        <input type="date" v-model="formData.date">
      </div>
      
      <div class="form-group">
        <label>Start Time:</label>
        <input type="time" v-model="formData.startTime">
      </div>
      
      <div class="form-group">
        <label>Duration (minutes):</label>
        <input type="number" v-model="formData.duration" min="30">
      </div>
      
      <div class="form-group">
        <label>School:</label>
        <select v-model="formData.school_id">
          <option 
            v-for="school in schools" 
            :key="school.school_id" 
            :value="school.school_id"
          >
            {{ school.name }}
          </option>
        </select>
      </div>
      
      <div class="modal-actions">
        <button @click="$emit('close')">Cancel</button>
        <button @click="saveSession">Save</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import { useQuery, useMutation } from '@vue/apollo-composable';
import { GET_SCHOOLS, CREATE_COURSE_SESSION, UPDATE_COURSE_SESSION } from '../graphql/queries';

// Props
const props = defineProps({
  course: Object,
  session: Object
})

// Emit
const emit = defineEmits(['save', 'close'])

// Data
// const { result: schoolsResult } = useQuery(GET_SCHOOLS);
const schoolsResult = {
  value: {
    schools: [
      { school_id: 1, name: "曉明" },
      { school_id: 2, name: "育仁" },
    ]
  }
};
const schools = computed(() => schoolsResult.value?.schools || []);
const isEdit = computed(() => !!props.session);

// Form
const formData = ref({
  date: '',
  startTime: '09:00',
  duration: 90,
  school_id: ''
})

// Initialize form if editing
watch(() => props.session, (session) => {
  if (session) {
    const start = new Date(session.start_at)
    formData.value = {
      date: start.toISOString().split('T')[0],
      startTime: start.getHours().toString().padStart(2, '0') + ':' + 
                start.getMinutes().toString().padStart(2, '0'),
      duration: Math.round((new Date(session.end_at) - start) / (1000 * 60)),
      school_id: session.school.school_id
    }
  }
}, { immediate: true });

// Mutations
const { mutate: createSession } = useMutation(CREATE_COURSE_SESSION)
const { mutate: updateSession } = useMutation(UPDATE_COURSE_SESSION)

const saveSession = async () => {
  const start = new Date(`${formData.value.date}T${formData.value.startTime}`)
  const end = new Date(start.getTime() + formData.value.duration * 60000)
  
  const input = {
    course_id: props.course.course_id,
    school_id: formData.value.school_id,
    start_at: start.toISOString(),
    end_at: end.toISOString()
  }

  if (isEdit.value) {
    await updateSession({
      session_id: props.session.session_id,
      input
    })
  } else {
    await createSession({ input })
  }
  
  emit('save')
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  background: white;
  padding: 20px;
  border-radius: 5px;
  width: 400px;
}

.form-group {
  margin-bottom: 15px;
}

label {
  display: block;
  margin-bottom: 5px;
}

input, select {
  width: 100%;
  padding: 8px;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}
</style>